import { ICompanyDataModel } from '../../data-models/company.data-model';
import { customFieldsListAtom } from '../../services/state/AdminPanel/CustomFieldsStateJ';
import {
  formulaFieldsEnabledAtom,
  formulaFieldsListAtom,
} from '../../services/state/AdminPanel/FormulaFieldsStateJ';
import { batchSetCompaniesAtom } from '../../services/state/CompanyStateJ';
import { kpiTemplatesListStateJ } from '../../services/state/KPI/KPITemplatesStateJ';
import { portcoIdsStateJ } from '../../services/state/PortCosStateJ';
import { SampleSeed, seed } from './SampleScope';

/**
 * What every sample store starts from: the sample portfolio written the way the app writes it,
 * and the admin lists grid schemas resolve against, empty. A module seeds its own on top.
 */
export function baseSampleSeeds(companies: ICompanyDataModel[]): SampleSeed[] {
  return [
    seed(
      portcoIdsStateJ,
      companies.map((company) => company.id)
    ),
    seed(batchSetCompaniesAtom, companies),
    seed(kpiTemplatesListStateJ, []),
    seed(customFieldsListAtom, []),
    seed(formulaFieldsListAtom, []),
    // Off, so the column pipeline stops waiting on formula fields the sample has none of.
    seed(formulaFieldsEnabledAtom, false),
  ];
}
